import { memo, ReactElement } from 'react';
import LogoutIcon from '@mui/icons-material/Logout';
import { Button } from '@mui/material';

export interface SessionLogoutButtonProps {
  onSessionExit: () => void;
}

export const SessionLogoutButton = memo(function SessionLogoutButton({
  onSessionExit,
}: SessionLogoutButtonProps): ReactElement {
  return (
    <Button color='error' variant='contained' onClick={onSessionExit} size='small' sx={{ borderRadius: '10px' }}>
      <LogoutIcon />
    </Button>
  );
});
